import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clone } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "~shared/api";
import { getFixtureListQueryKey } from "./useFetchAllSeasonFixtures";

type FixtureProperties = {
  fixtureId: string;
  locked: boolean;
};

export const useLockUnlockFixture = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const queryClient = useQueryClient();
  const { mutateData } = useApi();
  const mutateFunc = async (properties: FixtureProperties) => {
    return await mutateData({
      url: `${sport}/o/${organizationId}/fixtures/${properties.fixtureId}/${properties.locked ? "unlock" : "lock"}`,
      method: "POST",
    });
  };

  const onSuccessHandler = (response: any, properties: FixtureProperties) => {
    if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
      queryClient.setQueryData(getFixtureListQueryKey({ sport, organizationId, seasonId }), (oldFixtures: []) => {
        return (oldFixtures || []).map((oldFixture: any) => {
          if (oldFixture.fixtureId === properties.fixtureId) {
            const clonedFixture = clone(oldFixture);
            clonedFixture.locked = !clonedFixture.locked;
            return clonedFixture;
          }
          return oldFixture;
        });
      });
    }
  };

  return useMutation({
    mutationFn: mutateFunc,
    onSuccess: onSuccessHandler,
  });
};
